import React from "react";
import { ReactSVG } from "react-svg";
import { PreviewLayout } from "./";
import { Link } from "../Link";
import { Typography } from "../Typography";
import { Lazy } from "../Lazy";
import { IconList } from "../IconList";
import { checkValidURL } from "@/utils/formHelper";
import {
  QREditorContextProps,
  QRProps,
} from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";

export default function PreviewApps(props: QRProps<"apps">) {
  const qrEditorContextData =
    React.useContext<QREditorContextProps<"apps">>(QREditorContext);
  const data = props?.data || qrEditorContextData?.qrData.data;
  const isInitPreview = props?.initPreview;
  const {
    themeColor,
    appLinks,
    appsCompany,
    appsDescription,
    appsName,
    appsWebsite,
    logoUrl,
  } = data;

  React.useEffect(() => {
    // avoid go to next step if apps links haven't been given
    if (!isInitPreview) {
      const appLinksExist = data.appLinks && data.appLinks.length > 0;
      !appLinksExist
        ? qrEditorContextData.setValidationError(true)
        : qrEditorContextData.setValidationError(false);
    }
  }, [data]);

  return (
    <PreviewLayout
      page="apps"
      dataQA="preview-apps-container"
      backgroundColor={themeColor?.backgroundColor}
      includeBrowser
      initPreview={isInitPreview}
    >
      <div style={{ position: "relative" }}>
        <div
          className="background-divider-top"
          style={{ backgroundColor: themeColor?.buttonColor }}
        />
        <div className="background-divider-bottom" />
        <div className="business-logo-background">
          {logoUrl ? (
            <div className="logoUrl--container">
              <Lazy placeholderClass="logoUrl--background">
                <img
                  src={optimizeCloudinaryImage({
                    url: logoUrl,
                    transformations: ["w_400,h_400,q_90,f_auto,c_fill"],
                  })}
                  className="logoUrl--background"
                />
              </Lazy>
            </div>
          ) : (
            <div className="u-imagePlaceholder u-spacing-4">
              <div className="u-imagePlaceholder__wrapper">
                <ReactSVG
                  className="u-imagePlaceholder__svg"
                  src="/svg/icon-image.svg"
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="qr-content">
        {appsName && (
          <div className="appsName">
            <Typography Tag="p" size="l" classname="u-semibold u-spacing-4">
              {appsName}
            </Typography>
          </div>
        )}

        {appsCompany && (
          <Typography Tag="p" size="s">
            {appsCompany}
          </Typography>
        )}

        <div
          className={`u-card u-card--dark u-card--image u-card--center u-spacing-5`}
          style={{ backgroundColor: themeColor?.buttonColor }}
        >
          <Typography Tag="p" size="s">
            {appsDescription}
          </Typography>
          {appLinks && (
            <div className="qr-apps">
              <IconList center column items={appLinks} />
            </div>
          )}
        </div>

        {appsWebsite && (
          <Link
            className="Preview-layout__link"
            href={checkValidURL(appsWebsite) || ""}
            externalLink
          >
            {appsWebsite}
          </Link>
        )}
      </div>
    </PreviewLayout>
  );
}
